import React from 'react'
import { Image } from 'antd'
import { useTranslation } from 'react-i18next'

import img1 from '../../../../shared/assets/IMG_1691.jpeg'
import img2 from '../../../../shared/assets/IMG_1704.jpeg'
import img3 from '../../../../shared/assets/IMG_1705_1.jpeg'
import { PageSection } from '../../../../shared/ui/PageSection'
import cls from './GallerySection.module.scss'

const images = [img1, img2, img3]

const GallerySection: React.FC = () => {
    const { t } = useTranslation()

    return (
        <PageSection
            title={t('gallery.title')}
            variant="compact"
            style={{ backgroundColor: '#f4f2e8' }}
        >
            <Image.PreviewGroup>
                <ul className={cls.grid}>
                    {images.map((src, index) => (
                        <li key={index} className={cls.cell}>
                            <Image
                                src={src}
                                alt={`${t('gallery.title')} ${index + 1}`}
                                rootClassName={cls.imageRoot}
                                className={cls.image}
                                loading="lazy"
                                preview
                            />
                        </li>
                    ))}
                </ul>
            </Image.PreviewGroup>
        </PageSection>
    )
}

export default GallerySection
